import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { securityApi, type AuditRecord } from '../../api/security';

export function AuditExplorerPage() {
  const [records, setRecords] = useState<AuditRecord[]>([]);
  useEffect(() => { void securityApi.audit().then(setRecords); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Audit Explorer</h1>
      <Link to="/security" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← SOC Hub</Link>
      <ul className="mt-6 space-y-2">{records.map((r) => (
        <li key={r.id} className="rounded border px-3 py-2 text-sm dark:border-slate-700">{r.actor} · {r.action} · {r.resource} · {r.outcome}</li>
      ))}{records.length === 0 && <p className="text-sm text-slate-500">No audit records yet.</p>}</ul>
    </div>
  );
}
